import React, { useEffect } from 'react'
import { useMessageCenter } from '~/context'
import { IHealthProcedures } from '~/interfaces'
import { transformDate } from '~/utils'

interface MedicalAppointmentDetailsProps {
  healthProcedure: IHealthProcedures
}

export const MedicalAppointmentDetails = ({ healthProcedure }: MedicalAppointmentDetailsProps): JSX.Element => {
  const { throwErrorModal } = useMessageCenter()

  useEffect(() => {
    const description = healthProcedure.description
    const date = transformDate({ date: healthProcedure.startDate })
    const modalInformation = {
      title: '',
      subtitle: `O conteúdo da ${description} do dia ${date} não está disponível por questões de sigilo médico.`,
      buttonMessage: 'Fechar'
    }

    throwErrorModal(modalInformation)
  }, [healthProcedure, throwErrorModal])

  return <></>
}
